import * as CubeTree from '../../../cubeTree/index';
import CodiSystem from '../../../codiSystem/index';
import Utils from '../../../utils/util';

class ArrowBase {
    protected $arrow: JQuery<HTMLElement>;
    protected $line: JQuery<HTMLElement>;
    protected isShow: boolean = false;
    protected target: CubeId|null = null;
    protected direction: PointOfRectDirection|null = null;

    constructor() {
        this.$arrow = $('#shelvesbuild__drag-arrow');
        this.$line = $('#shelvesbuild__drag-line');
    }

    protected pointToLayerCube(): void {
        let targetCoordinate: PaintCoordinate = CodiSystem.getPaintCoordinate(this.target);
        let arrowLeft: LogicsicsMeasurement = 0;
        let halfHeight: LogicsicsMeasurement = Utils.math(targetCoordinate.height, 2, '/');
        let halfWidth: LogicsicsMeasurement = Utils.math(targetCoordinate.width, 2, '/');
        let arrowTop: LogicsicsMeasurement = Utils.math(Utils.math(targetCoordinate.top, halfHeight, '+'), 18, '-');
        let lineLeft: LogicsicsMeasurement = 0;
        let lineTop: LogicsicsMeasurement = 0;

        this.reset();
        if (this.direction === 'left') {
            arrowLeft = Utils.math(targetCoordinate.left, 46, '-');
            lineLeft = targetCoordinate.left;
            this.arrowToSlide({
                arrowLeft,
                arrowTop,
                lineLeft
            });
            return;
        }

        if (this.direction === 'right') {
            arrowLeft = Utils.math(Utils.math(targetCoordinate.left, targetCoordinate.width, '+'), 46, '-');
            lineLeft = Utils.math(targetCoordinate.left, targetCoordinate.width, '+');
            this.arrowToSlide({
                arrowLeft,
                arrowTop,
                lineLeft
            });
            return;
        }

        // middle
        arrowLeft = Utils.math(Utils.math(targetCoordinate.left, halfWidth, '+'), 14, '-');
        arrowTop = Utils.math(targetCoordinate.top, 46, '-');
        lineTop = targetCoordinate.top;
        this.arrowToDown({
            arrowLeft,
            arrowTop,
            lineTop
        });
    }

    protected pointToCabinetCube(insertInfo: CabinetCubeInsertInfo): void {
        if (insertInfo.direction !== 'top'
            && insertInfo.direction !== 'bottom') {
            this.arrowToSlide({
                arrowLeft: Utils.math(insertInfo.arrowPosition.left, 46, '-'),
                arrowTop: Utils.math(insertInfo.arrowPosition.top, 18, '-'),
                lineLeft: insertInfo.arrowPosition.left
            });
            return;
        }

        this.arrowToDown({
            arrowLeft: Utils.math(insertInfo.arrowPosition.left, 14, '-'),
            arrowTop: Utils.math(insertInfo.arrowPosition.top, 46, '-'),
            lineTop: insertInfo.arrowPosition.top
        });
    }

    protected arrowToSlide(params: ArrowToSlideParams): void {
        this.$arrow
            .removeClass('shelvesbuild__drag-arrow--down')
            .addClass('shelvesbuild__drag-arrow--right');
        this.$arrow.css({
            transform: `translate(${params.arrowLeft}px, ${params.arrowTop}px)`
        });
        this.$line
            .addClass('shelvesbuild__drag-line--col')
            .removeClass('shelvesbuild__drag-line--row')
            .css({
                transform: `translate(${params.lineLeft}px, 0px)`
            });
    }

    protected arrowToDown(params: ArrowToDown): void {
        this.$arrow
            .removeClass('shelvesbuild__drag-arrow--right')
            .addClass('shelvesbuild__drag-arrow--down');
        this.$arrow.css({
            transform: `translate(${params.arrowLeft}px, ${params.arrowTop}px)`
        });
        this.$line
            .addClass('shelvesbuild__drag-line--row')
            .removeClass('shelvesbuild__drag-line--col')
            .css({
                transform: `translate(0px, ${params.lineTop}px)`
            });
    }

    protected pointToLayer(): void {
        let targetCoordinate: PaintCoordinate = CodiSystem.getPaintCoordinate(this.target);
        let halfWidth: LogicsicsMeasurement = Utils.math(targetCoordinate.width, 2, '/');
        let arrowLeft: LogicsicsMeasurement = Utils.math(Utils.math(targetCoordinate.left, halfWidth, '+'), 18, '-');
        let arrowTop: LogicsicsMeasurement = Utils.math(targetCoordinate.top, 46, '-');
        let lineTop: LogicsicsMeasurement = targetCoordinate.top;

        this.reset();
        this.$arrow.addClass('shelvesbuild__drag-arrow--down');

        if (CubeTree.isBeam(this.target)) {
            arrowTop = Utils.math(targetCoordinate.top, 10, '-');
            this.$arrow
                .css({
                    transform: `translate(${arrowLeft}px, ${arrowTop}px) rotate(-135deg)`
                });
        }
        else {
            this.$arrow
                .css({
                    transform: `translate(${arrowLeft}px, ${arrowTop}px) rotate(-45deg)`
                });
        }

        this.$line
            .addClass('shelvesbuild__drag-line--row')
            .css({
                transform: `translate(0px, ${lineTop}px)`
            });
    }

    protected pointToCabinet(target: CubeId): void {
        let targetCoordinate: PaintCoordinate = CodiSystem.getPaintCoordinate(target);
        let halfWidth: LogicsicsMeasurement = Utils.math(targetCoordinate.width, 2, '/');
        let arrowLeft: LogicsicsMeasurement = Utils.math(Utils.math(targetCoordinate.left, halfWidth, '+'), 18, '-');
        let lineTop: LogicsicsMeasurement = Utils.math(targetCoordinate.top, targetCoordinate.height, '+');
        let arrowTop: LogicsicsMeasurement = Utils.math(lineTop, 46, '-');

        this.reset();
        this.$arrow.addClass('shelvesbuild__drag-arrow--down');
        this.$arrow
            .css({
                transform: `translate(${arrowLeft}px, ${arrowTop}px) rotate(-45deg)`
            });
        this.$line
            .addClass('shelvesbuild__drag-line--row')
            .css({
                transform: `translate(0px, ${lineTop}px)`
            });
    }

    protected pointToShelf(): void {
        let targetCoordinate: PaintCoordinate = CodiSystem.getPaintCoordinate(this.target);
        let arrowLeft: LogicsicsMeasurement = 0;
        let halfHeight: LogicsicsMeasurement = Utils.math(targetCoordinate.height, 2, '/');
        let arrowTop: LogicsicsMeasurement = Utils.math(Utils.math(targetCoordinate.top, halfHeight, '+'), 18, '-');
        let lineLeft: LogicsicsMeasurement = 0;

        this.reset();
        if (this.direction === 'left') {
            arrowLeft = Utils.math(targetCoordinate.left, 46, '-');
            lineLeft = targetCoordinate.left;
        }
        else {
            arrowLeft = Utils.math(Utils.math(targetCoordinate.left, targetCoordinate.width, '+'), 46, '-');
            lineLeft = Utils.math(targetCoordinate.left, targetCoordinate.width, '+');
        }

        this.$arrow.addClass('shelvesbuild__drag-arrow--right');
        this.$arrow.css({
            transform: `translate(${arrowLeft}px, ${arrowTop}px)`
        });
        this.$line
            .addClass('shelvesbuild__drag-line--col')
            .css({
                transform: `translate(${lineLeft}px, 0px)`
            });
    }

    protected destroy(): void {
        this.$arrow.removeClass('shelvesbuild__drag-arrow--left shelvesbuild__drag-arrow--right shelvesbuild__drag-arrow--down');
        this.$line.removeClass('shelvesbuild__drag-line--col shelvesbuild__drag-line--row');
    }

    protected reset(): void {
        this.destroy();
    }
};

export default ArrowBase;
